import { render, staticRenderFns } from "./TierManagement.vue?vue&type=template&id=67522ee9&"
import script from "./TierManagement.vue?vue&type=script&lang=js&"
export * from "./TierManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports